import React from 'react'
import {useIntl} from 'react-intl'
import {Navigate, Outlet, Route, Routes} from 'react-router-dom'
import {ClientsListPage} from './pages/ClientsListPage'
import {ClientEditPage} from './pages/ClientEditPage'
import {ClientAddPage} from './pages/ClientAddPage'
import {ClientShowPage} from './pages/ClientShowPage'
import {ClientDetails} from './pages/client/ClientDetails'
import {ClientContacts} from './pages/client/ClientContacts'
import {ClientAdresses} from './pages/client/ClientAdresses'
import {ClientAdresseAdd} from './pages/client/ClientAdresseAdd'
import {ClientAdresseEdit} from './pages/client/ClientAdresseEdit'
import {ClientContactAdd} from './pages/client/ClientContactAdd'
import {ClientContactEdit} from './pages/client/ClientContactEdit'
import {ClientDemandes} from './pages/client/ClientDemandes'
import {ClientAcomptes} from './pages/client/ClientAcomptes'
import {ClientHistoriqueFacturation} from './pages/client/ClientHistoriqueFacturation'
import {ClientEncours} from './pages/client/ClientEncours'
import {ClientDocument} from './pages/client/ClientDocument'
import {ClientRemises} from './pages/client/ClientRemises'
import {ClientParametrage} from './pages/client/ClientParametrage'
import {ClientReseaux} from './pages/client/ClientReseaux'
import {PageTitle} from '../../../../_metronic/layout/core'

const ClientsWrapper = () => {
  const intl = useIntl()
  const clientListLink = {
    title: 'Client', path: '/vente/clients/liste', isSeparator: false, isActive: true
  }

  return (
    <>
      <Routes>
        <Route
          path='liste'
          element={
            <>
              <PageTitle breadcrumbs={[
                { title: 'Clients', path: '#', isSeparator: false, isActive: false },
              ]}>Liste</PageTitle>
              <ClientsListPage/>
            </>
          }
        />
        <Route
          path='ajouter'
          element={
            <>
              <PageTitle breadcrumbs={[
                clientListLink
              ]}>Création</PageTitle>
              <ClientAddPage/>
            </>
          }
        />
        <Route
          path=':clientId/modifier'
          element={
            <>
              <PageTitle breadcrumbs={[
                clientListLink,
              ]}>Modification</PageTitle>
              <ClientEditPage/>
            </>
          }
        />
        <Route
          path=':clientId/afficher/*'
          element={
            <>
              <PageTitle breadcrumbs={[
                clientListLink,
              ]}>Fiche</PageTitle>
              <ClientShowPage/>
              <Outlet/>
            </>
          }
        >
          <Route
            index
            element={
              <>
                <ClientDetails/>
              </>
            }
          />
          <Route
            path='contacts'
            element={
              <>
                <PageTitle breadcrumbs={[
                  clientListLink,
                ]}>Contacts</PageTitle>
                <ClientContacts/>
              </>
            }
          />
          <Route
            path='contacts/ajouter'
            element={
              <>
                <ClientContactAdd/>
              </>
            }
          />
          <Route
            path='historique-facturation'
            element={
              <>
                <PageTitle breadcrumbs={[
                  clientListLink,
                ]}>Historique facturation</PageTitle>
                <ClientHistoriqueFacturation/>
              </>
            }
          />

          <Route
            path='client-encours-paiement'
            element={
              <>
                <PageTitle breadcrumbs={[
                  clientListLink,
                ]}>En cours</PageTitle>
                <ClientEncours/>
              </>
            }
          />

          <Route
            path='contacts/:contactId/modifier'
            element={
              <>
                <ClientContactEdit/>
              </>
            }
          />
          <Route
            path='adresses'
            element={
              <>
                <PageTitle breadcrumbs={[
                  clientListLink,
                ]}>Adresses</PageTitle>
                <ClientAdresses/>
              </>
            }
          />
          <Route
            path='adresses/ajouter'
            element={
              <>
                <ClientAdresseAdd/>
              </>
            }
          />
          <Route
            path='adresses/:adresseId/modifier'
            element={
              <>
                <ClientAdresseEdit/>
              </>
            }
          />
          <Route
            path='demandClient'
            element={
              <>
                <PageTitle breadcrumbs={[
                  clientListLink,
                ]}>Demandes</PageTitle>
                <ClientDemandes/>
              </>
            }
          />
          <Route
            path='acomptes'
            element={
              <>
                <PageTitle breadcrumbs={[
                  clientListLink,
                ]}>Acomptes</PageTitle>
                <ClientAcomptes/>
              </>
            }
          />
          <Route
            path='document'
            element={
              <>
                <PageTitle breadcrumbs={[
                  clientListLink,
                ]}>Document</PageTitle>
                <ClientDocument/>
              </>
            }
          />
          <Route
            path='remises'
            element={
              <>
                <PageTitle breadcrumbs={[
                  clientListLink,
                ]}>Remises</PageTitle>
                <ClientRemises/>
              </>
            }
          />
          <Route
            path='parametrage'
            element={
              <>
                <PageTitle breadcrumbs={[
                  clientListLink,
                ]}>Paramétrage</PageTitle>
                <ClientParametrage/>
              </>
            }
          />
          <Route
            path='reseau-client'
            element={
              <>
                <PageTitle breadcrumbs={[
                  clientListLink,
                ]}>Réseaux</PageTitle>
                <ClientReseaux/>
              </>
            }
          />
        </Route>
        <Route index element={<Navigate to='/vente/clients/liste'/>}/>
      </Routes>
    </>
  )
}

export {ClientsWrapper}
